import {
    allFetch
} from "../Domain";

/**
 * @description 車輛進廠推播
 */
export const CarNotification = (() => {
    /**
     * @description 車輛進廠紀錄
     */
    const CarLicenseRecordSearch = async function (obj = {
        page: '0',
        num_per_page: '1',
    }) {
        return await allFetch('Car/CarLicenseRecordSearch', obj);
    }

    /**
     * @description 預約紀錄查詢
     */
    const AppointmentSearch = async function (obj = {
        car_id: '',
        page: '0',
        num_per_page: '1',
    }) {
        return await allFetch('Appointment/AppointmentSearch', obj);
    }

    /**
     * @description 維修紀錄查詢
     */
    const WorkOrderMasterSearch = async function (obj = {
        car_id: '',
        is_invalid: 'N',
    }) {
        return await allFetch('WorkOrder/WorkOrderMasterSearch', obj);
    }

    /**
     * @description 車籍明細查詢
     */
    const CarDetail = async function (obj = {
        car_id: '',
    }) {
        return await allFetch('Car/CarDetail', obj);
    }

    /**
     * @description 車主查詢
     */
    const CustomerSearch = async function (obj = {
        car_id: '',
    }) {
        return await allFetch('Customer/CustomerSearch', obj);
    }

    /**
     * @description 工單查詢
     */
    const RepairListDetailSearch = async function (obj = {
        wom_id: '',
    }) {
        return await allFetch('WorkOrder/RepairListDetailSearch', obj);
    }
    return {
        CarLicenseRecordSearch,
        AppointmentSearch,
        WorkOrderMasterSearch,
        CarDetail,
        CustomerSearch,
        RepairListDetailSearch
    }
})();